import { render, staticRenderFns } from "./indicator-form-tab1.vue?vue&type=template&id=2b635250&scoped=true&"
import script from "./indicator-form-tab1.vue?vue&type=script&lang=ts&"
export * from "./indicator-form-tab1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b635250",
  null
  
)

export default component.exports